export function sanitizeHtml(content: string) {
  const documentValue = new DOMParser().parseFromString(content, "text/html");
  documentValue
    .querySelectorAll(
      "script, style, iframe, object, embed, form, input, button",
    )
    .forEach((node) => node.remove());
  documentValue.querySelectorAll("*").forEach((node) => {
    for (const attribute of [...node.attributes]) {
      if (
        attribute.name.startsWith("on") ||
        ((attribute.name === "href" || attribute.name === "src") &&
          attribute.value.trim().toLowerCase().startsWith("javascript:"))
      ) {
        node.removeAttribute(attribute.name);
      }
    }
    if (node instanceof HTMLAnchorElement) {
      node.target = "_blank";
      node.rel = "noopener noreferrer";
    }
  });
  return documentValue.body.innerHTML;
}

export function htmlToText(content: string) {
  const documentValue = new DOMParser().parseFromString(content, "text/html");
  return String(documentValue.body.textContent || "")
    .replace(/\s+/g, " ")
    .trim();
}
